'use client';
import { useRef, useState, useEffect } from 'react';
import Tooltip from 'atoms/Tooltip';

const TruncatedTextWithTooltip = ({
    text,
    insideText,
    lengthThreshold = 19,
    tooltipPosition = "bottomLeft",
    tooltipWidth = "w-[200px]",
    maxWidth = "max-w-[154px]",
    className = "",
    tooltipClass = '',
    bottomSpace = 150,
    tooltipContentClass= "whitespace-normal"
}) => {
    if (!text) return null;

    const ref = useRef(null);
    const [position, setPosition] = useState(tooltipPosition);
    const shouldShowTooltip = text.length > lengthThreshold;

    useEffect(() => {
        if (!ref.current || !shouldShowTooltip) return;
        const rect = ref.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const neededSpace = bottomSpace;
        if (spaceBelow < neededSpace) {
            setPosition("topLeft");
        } else {
            setPosition(tooltipPosition);
        }
    }, [shouldShowTooltip, tooltipPosition]);

    if (!shouldShowTooltip) {
        return (
            <div className={`whitespace-nowrap overflow-hidden text-ellipsis text-sm ${maxWidth} ${className}`}>
                {insideText || text}
            </div>
        );
    }

    return (
        <Tooltip
            text={text}
            position={position}
            width={tooltipWidth}
            tooltipClass={tooltipClass}
            tooltipContentClass={tooltipContentClass}
        >
            <div
                ref={ref}
                className={`text-sm whitespace-nowrap overflow-hidden text-ellipsis ${maxWidth} ${className}`}
            >
                {insideText || text}
            </div>
        </Tooltip>
    );
};

export default TruncatedTextWithTooltip;
